var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-confirm-container"},[_c('c-confirm-message',{directives:[{name:"show",rawName:"v-show",value:(_vm.confirm.open),expression:"confirm.open"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }